module.exports = __webpack_public_path__ + "static/media/Marsh_Badge.9fd8d946.png";